/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_8Inputs */

const en_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import over 30 different subtitle file formats`)
};

const fr_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation de plus de 30 formats de fichiers de sous-titres différents`)
};

const de_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie über 30 verschiedene Untertiteldateiformate`)
};

const it_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa oltre 30 diversi formati di file di sottotitoli`)
};

const ru_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте более 30 различных форматов файлов субтитров.`)
};

const es_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa más de 30 formatos de archivos de subtítulos diferentes`)
};

const zh_cn2_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入超过 30 种不同的字幕文件格式`)
};

const ja_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30種類以上の字幕ファイル形式をインポート`)
};

const hi_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 से अधिक विभिन्न उपशीर्षक फ़ाइल स्वरूपों को आयात करें`)
};

const pt_pt2_signup_feature_pro_8 = /** @type {(inputs: Signup_Feature_Pro_8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe mais de 30 formatos de arquivo de legenda diferentes.`)
};

/**
* | output |
* | --- |
* | "Import over 30 different subtitle file formats" |
*
* @param {Signup_Feature_Pro_8Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_8 = /** @type {((inputs?: Signup_Feature_Pro_8Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_8Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_8(inputs)
	if (locale === "de") return de_signup_feature_pro_8(inputs)
	if (locale === "it") return it_signup_feature_pro_8(inputs)
	if (locale === "ru") return ru_signup_feature_pro_8(inputs)
	if (locale === "es") return es_signup_feature_pro_8(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_8(inputs)
	if (locale === "ja") return ja_signup_feature_pro_8(inputs)
	if (locale === "hi") return hi_signup_feature_pro_8(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_8(inputs)
	return en_signup_feature_pro_8(inputs)
});